import { useEffect, useState } from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { APPOINTMENT_STATUS } from '../../../phan-he-tiep-nhan-thanh-toan/components/tab-tiep-nhan/tab-danh-sach-dat-lich-hen/constants';
import DatLichHenKhamModal from './DatLichHenKhamModal';

type Props = ButtonProps & {
	patientInfo: any;
	itemEdit?: any;
	onSuccess?: () => void;
};

const DatLichHenButton = ({ patientInfo, itemEdit, onSuccess, ...props }: Props) => {
	const [openModalDatLich, setOpenModalDatLich] = useState(false);

	const [appointmentItem, setAppointmentItem] = useState();

	useEffect(() => {
		setAppointmentItem(itemEdit);
	}, [itemEdit?.id]);

	const isValidItem = (item: any) => {
		return (
			item?.id &&
			![
				APPOINTMENT_STATUS.APPOINTMENT_COMPLETED,
				APPOINTMENT_STATUS.APPOINTMENT_CANCELED,
			].includes(item?.currStatusCode)
		);
	};

	return (
		<>
			<Button
				className="btn-fill spaces px-16"
				{...props}
				onClick={() => setOpenModalDatLich(true)}
			>
				{isValidItem(appointmentItem) ? 'Sửa' : 'Đặt'} lịch hẹn khám lại
			</Button>

			{openModalDatLich && (
				<DatLichHenKhamModal
					open={openModalDatLich}
					onClose={() => setOpenModalDatLich(false)}
					patientInfo={patientInfo}
					itemEdit={isValidItem(appointmentItem) ? appointmentItem : null}
					onSave={(data) => {
						setAppointmentItem(data);
						onSuccess?.();
					}}
				/>
			)}
		</>
	);
};

export default DatLichHenButton;
